import { render } from "./view-mode.vue?vue&type=template&id=928b1df4&lang=pug"
import script from "./view-mode.vue?vue&type=script&setup=true&lang=js"
export * from "./view-mode.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__